import { api } from '@/api/auth'  // adjust the path as needed
import type { Farm } from '@/types/Farm'
import type { PaginatedResponse } from '@/types/api'


export async function fetchFarmsAPI(): Promise<Farm[]> {
  const res = await api.get('farms/')
  return res.data
}

export async function createFarmAPI(data: Farm): Promise<Farm> {
  const res = await api.post('farms/', data)
  return res.data
}

export async function updateFarmAPI(id: string, data: Farm): Promise<Farm> {
  const res = await api.put(`farms/${id}/`, data)
  return res.data
}

export async function deleteFarmAPI(id: string): Promise<void> {
  await api.delete(`farms/${id}/`)
}
export const getFarms = () => api.get<PaginatedResponse<Farm>>('farms/')
